import axios from 'axios'
import qs from 'qs' //json字符串转为表单格式插件
import store from './../store'
import EventBus from './../utils/eventBus'
import router from './../router'
import api from './api'

const service = axios.create()
// 超时后最多重复请求次数
service.defaults.retry = 4
service.defaults.retryDelay = 1000

// 添加请求拦截器
service.interceptors.request.use(function (config) {
  //在拦截器里统一处理将json参数格式改成表达格式
  let param = config.data;
  // 自动添加uid和token数据
  let uid = window.localStorage.getItem('uid')
  let token = window.localStorage.getItem('token')
  if (typeof param === 'object' && uid && token) {
    param.uid = uid
    param.token = token
  }
  if (config.headers['Content-Type'] !== 'mutipart/form-data') {
    config.data = qs.stringify(param);
  }
  // 在发送请求之前做些什么
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
service.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  if (api[response.config.url] && api[response.config.url].specil) return response
  if (response.data.data) {
    let code = response.data.data.code
    let msg = response.data.data.msg
    if(code === 700) { // 登录失效后，清除登录信息，并跳转至首页
      localStorage.removeItem('uid');
      localStorage.removeItem('token');
      store.commit('getUserInfo', {})
      EventBus.$emit('loginOut')
      router.push('/')
    }
    if (code !== 0) {
      if (msg) store.commit('setMessage', {msg, type: 'error'})
      return Promise.reject(msg)
    }
  }
  return Promise.resolve(response.data.data)
}, function (error) {
  let config = error.config
  if (!config || !config.retry || !error.message.includes('timeout')) return Promise.reject(error)
  config.__retryCount = config.__retryCount || 0
  if (config.__retryCount >= config.retry) {
    return Promise.reject(error)
  }
  config.__retryCount += 1
  let backoff = new Promise((resolve) => {
    setTimeout(() => resolve(), config.retryDelay || 1)
  })
  return backoff.then(function() {
    return axios(config)
  })
});

export default service



// WEBPACK FOOTER //
// ./src/http/http.js